import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { GoodFilmDarkSVG } from '@/components/Icons/GoodFilmDarkSvg';
import { GoodFilmLightSVG } from '@/components/Icons/GoodFilmLightSvg';
import { QuotationDarkSvg } from '@/components/Icons/QuotationDarkSvg';
import { QuotationLightSvg } from '@/components/Icons/QuotationLightSvg';
import { Statements } from '@/components/Statements/Statements';
import { useColorMode } from '@/hooks';
import { InfoGrid, RightBlockGrid } from './LoginForm.styles';

export const LoginWrap = ({ children }: { children: ReactNode }) => {
    const isDarkMode = useColorMode();
    return (
        <div className="flex flex-wrap w-full justify-around">
            <div className="text-center relative">
                <Box
                    component="img"
                    src={isDarkMode ? '/images/login-dark.jpg' : '/images/login-light.jpg'}
                    sx={{
                        position: 'fixed',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: -1000,
                    }}
                />
                <div className="max-w-[400px] relative">{children}</div>
            </div>
            <RightBlockGrid container>
                {isDarkMode ? <GoodFilmDarkSVG /> : <GoodFilmLightSVG />}
                <InfoGrid container>
                    {isDarkMode ? <QuotationDarkSvg /> : <QuotationLightSvg />}
                    <Statements />
                </InfoGrid>
            </RightBlockGrid>
        </div>
    );
};
